import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import IconTooltip from './IconTooltip'
import { AIChatAgentIcons } from '../../helpers/iconHelpers'
import { getTimezoneLabel, getUserTimezone, getUseDeviceTz } from '../../helpers/timeDisplaySettings'

const ViewingInTimezone = () => {
	const { t } = useTranslation('translation', { keyPrefix: 'eventsPage.viewingInTimezone' })
	const user = useSelector((state) => state.user.user)

	const getLabel = () => {
		if (getUseDeviceTz(user)) {
			return t('labelDeviceLocalTime')
		}

		const timeZone = getUserTimezone(user)
		return timeZone ? getTimezoneLabel(timeZone) : t('labelUserLocalTime')
	}

	const label = getLabel()

	return (
		<div className="viewing-in-timezone">
			<span className="viewing-in-timezone-label">
				<span className="viewing-in-timezone-icon">
					<AIChatAgentIcons.ClockIcon />
				</span>
				<span>{t('titleViewingIn')}:</span>
			</span>
			<span className="viewing-in-timezone-value">
				<span className="timezone-abbr">{label}</span>
				<IconTooltip description={t('description')} id="viewing-in-timezone-tooltip" placement="bottom" />
			</span>
		</div>
	)
}

export default ViewingInTimezone
